export default __webpack_public_path__ + "static/media/profile-image.95f4ca0e.jpg";